import styles from "../../styles/select.module.scss";

import { Icon } from "../../shared/components/core/Icon";

import classNames from "classnames/bind";
import { If } from "./control-statements";
import { InfoCircleGreen, InfoCircleGrey } from "./Icons";

export const Select = ({
  options,
  value,
  label,
  className = "",
  onChange,
  design = "one",
  disabled,
  readOnly,
  filled = null,
  placeholder,
  ...props
}) => {
  const cx = classNames.bind(styles);

  const { name, defaultValue } = props;
  const id = props.id || name;

  return (
    <div
      className={cx({
        selectContainer: true,
        [className]: className,
      })}
    >
      {label && (
        <label
          className={cx({
            label: true,
            [design]: design,
          })}
        >
          {label}
        </label>
      )}
      <div className={styles.relative}>
        <select
          id={id}
          onChange={onChange}
          className={cx({
            [design]: design,
          })}
          value={value}
          defaultValue={defaultValue}
          disabled={disabled}
          readOnly={readOnly}
          onMouseDown={(e) => {
            if (readOnly) {
              e.preventDefault();
            }
          }}
        >
          <If cond={placeholder}>
            <option value="" disabled selected>
              {placeholder}
            </option>
          </If>
          {options &&
            options.map((option) => (
              <option key={option.value + option.label} value={option.value}>
                {option.label}
              </option>
            ))}
        </select>

        <div className={styles.extras}>
          <span className={styles.chevron}>
            <svg
              width="9"
              height="6"
              viewBox="0 0 9 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.60444 4.68131C4.46853 4.81977 4.24492 4.81977 4.10901 4.68131L0.601518 1.10802C0.465603 0.969552 0.465603 0.741755 0.601518 0.60329C0.737433 0.464825 0.961035 0.464825 1.09695 0.60329L4.35672 3.92422L7.6165 0.603291C7.75241 0.464826 7.97602 0.464826 8.11193 0.603291C8.24785 0.741756 8.24785 0.969553 8.11193 1.10802L4.60444 4.68131Z"
                fill="#6F767E"
                stroke="#6F767E"
              />
            </svg>
          </span>
          <If cond={filled !== null}>
            <div className={styles.separator} />

            <If cond={filled === false}>
              <InfoCircleGrey />
            </If>

            <If cond={filled === true}>
              <InfoCircleGreen />
            </If>
          </If>
        </div>
      </div>
    </div>
  );
};
